
import viMessages from '../locales/vi_VI';

const ViLang = {
  messages: {
    ...viMessages,
  },
  locale: 'vi-VI',
 
};
export default ViLang;
